<div class="spacing--margin-horizontal spacing--margin-top">
  <agr-summary-card
    [title]="'cycle-overview.panel.' + panelSubject + '-title' | translate"
    [canExpand]="true"
    [actions]="getActions()"
  >
    <div>
      <ng-content></ng-content>
    </div>

    <div *ngIf="hasItems" class="padding-top">
      <div class="scroll-container">
        <div class="flex--row flex--nowrap">
          <div
            class="flex--column layout--padding-right"
            [ngClass]="'min-column-width-' + row.col_width"
            *ngFor="let row of totals"
          >
            <div class="text--small text--gray">{{ row.title }}</div>
            <div
              [attr.data-test]="
                'panel--' + panelSubject + '__' + row.title.substr(0, 6).toLowerCase()
              "
            >
              {{ row.value }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!hasItems && showAddButton">
      <a
        href
        [routerLink]="['/cycle', selectedCycle.id, panelSubject, 'add']"
        mat-flat-button
        color="primary"
      >
        <mat-icon>add</mat-icon>{{ 'cycle-overview.panel.add-' + panelSubject | translate }}
      </a>
    </ng-container>
  </agr-summary-card>
</div>
